/**
 * 客户管理-客户信息-编辑页
 * luxinwen
 * 2023-04-23
 */
<style scoped lang="less">
  @import "./edit.less";
</style>

<template>
  <div>
    <Drawer :title="title" v-model="myValue" width="900" :before-close="beforeClose">
      <div class="page-main-content">
        <div class="page-main-content-thead">参与人</div>
        <div class="page-main-content-tbody">
          <Row>
            <Col span="8">参与人名称：{{ formData.customerName }}</Col>
            <Col span="8">性别：{{ genderList[formData.gender] }}</Col>
            <Col span="8">电话：{{ formData.phone }}</Col>
            <Col span="24">参与活动名称：{{ formData.activityName }}</Col>
          </Row>
        </div>
      </div>
      <div class="page-main-content">
        <div class="page-main-content-thead">推荐人</div>
        <div class="page-main-content-tbody">
          <Row>
            <Col span="8">推荐人名称：</Col>
            <Col span="8">电话：</Col>
            <Col span="8">推荐时间：{{ formData.recommendTime }}</Col>
            <Col span="24">推荐剩余有效时间：</Col>
          </Row>
        </div>
      </div>
      <Divider />
      <div class="timeline">
        <Timeline>
          <TimelineItem :color="formData.commissionStatus < 1 ? 'gray' : 'blue'">
            <p class="title">推荐</p>
            <p class="time">{{ formData.recommendTime }}</p>
          </TimelineItem>
          <TimelineItem :color="formData.commissionStatus < 2 ? 'gray' : 'blue'">
            <p class="title">到访</p>
            <p class="time">{{ formData.visitTime }}</p>
          </TimelineItem>
          <TimelineItem :color="formData.commissionStatus < 3 ? 'gray' : 'blue'">
            <p class="title">认购</p>
            <p class="time">{{ formData.purchaseTime }}</p>
          </TimelineItem>
          <TimelineItem :color="formData.commissionStatus < 4 ? 'gray' : 'blue'">
            <p class="title">成交</p>
            <p class="time">{{ formData.transactionTime }}</p>
          </TimelineItem>
        </Timeline>
      </div>
      <Spin size="large" fix v-if="isLoading"></Spin>
    </Drawer>
  </div>
</template>

<script>
  import { GENDER } from '@/util/enum';
  const formData = {
    activityId: null, // 活动id
    activityName: '', // 活动名称
    buildingId: null, // 项目楼盘id
    buildingName: '', // 项目名称
    commissionAmount: null, // 佣金金额
    commissionStatus: null, // 佣金发放状态：0待发放/1发放中/2已发放/3发放异常
    customerName: '', // 客户姓名
    endRecommendTime: '', // 选择结束推荐时间
    endTransactionTime: '', // 选择结束成交时间
    gender: null, // 客户性别：1男0女
    memberId: '', // 推荐人账号
    phone: '',  // 客户手机号
    purchaseTime: '', // 认购时间
    recommendTime: '',  // 推荐时间
    searchKeyword: '',  // 搜索关键字：客户名称或手机号码
    startRecommendTime: '', // 选择开始推荐时间
    startTransactionTime: '', // 选择开始成交时间
    status: null, // 推荐状态：0已失效，1已推荐，2已来访，3已认购，4已成交
    transactionAmount: null,  // 成交金额
    transactionTime: '',  // 成交时间
    visitTime: ''  // 来访时间
  };

  export default {
    props: {
      value: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object,
        default() {
          return {};
        }
      },
      flag: {
        type: String
      }
    },
    data() {
      return {
        myValue: this.value,  // 是否显示抽屉
        isInit: false,        // 是否初始化
        isLoading: false,     // 是否加载中
        formData: Object.assign({}, formData),
        backupData: {},
        genderList: GENDER
      };
    },
    computed: {
      title() {
        return '查看客户信息';
      },
      isEqual() {
        return this.deepEqual(this.formData, this.backupData);
      },
      isShow() {
        return this.flag === 'show';
      },
      isEdit() {
        return this.flag === 'edit';
      }
    },
    methods: {
      /**
       * 初始化数据
       */
      initData(data = {}, isInit = false) {
        this.formData = this.deepCopy(formData);
        Object.keys(this.formData).forEach(item => {
          if (data.hasOwnProperty(item)) {
            this.formData[item] = data[item];
          }
        });
        if (isInit) {
          this.$nextTick(() => {
            this.backupData = this.deepCopy(this.formData);
            this.isInit = true;
          });
        }
      },
      /**
       * 获取数据
       */
      getData() {
        let isInit = !this.data.id;
        this.initData(this.data, isInit);
        if (isInit) return;
        this.$axios({
          url: this.$api.member.queryCustomerDetail,
          data: {
            id: this.data.id
          },
          beforeSend: () => {
            this.isLoading = true;
          },
          complete: () => {
            this.isLoading = false;
          }
        }).then(data => {
          this.initData(data, true);
        });
      },
      /**
       * 关闭前的回调
       */
      beforeClose() {
        return new Promise((resolve, reject) => {
          if (!this.isInit) {
            // 如果未初始化时快速点击关闭，则不做处理
          } else if (this.isEqual) {
            this.myValue = false;
          } else {
            this.$confirm('数据变更后未保存，是否直接关闭？').then(() => {
              this.myValue = false;
            });
          }
        });
      }
    },
    watch: {
      value(val) {
        this.myValue = val;
        if (this.myValue) {
          // 获取数据
          this.getData();
          // 隐藏页面滚动条
          document.querySelector('body').classList.add('hidden');
          // 重置内容域滚动条
          this.$nextTick(() => {
            let $drawer = document.querySelector('.ivu-drawer-body');
            if ($drawer) $drawer.scrollTo(0, 0);
          });
        } else {
          // 清除表单验证效果
          this.$refs.editForm && this.$refs.editForm.resetFields();
          // 重置初始化状态
          this.isInit = false;
          // 恢复页面滚动条
          document.querySelector('body').classList.remove('hidden');
        }
      },
      myValue(val) {
        this.$emit('input', val);
      }
    }
  };
</script>